import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { DataService } from './data.service';

@Injectable({
  providedIn: 'root'
})
export class DashboardDataServiceService {
  private baseUrl = environment.apiBaseUrl;

  constructor(private dataService: DataService) { }

  getPPPOEDetails(connectionId: number) {
    return this.dataService.getData('/api/Application/getPPPOEDetails/' + connectionId, false);
  }

  getIpAddress() {
    return this.dataService.getData('/api/GetIpAddress', true);
  }

  getConnectionDetails(connectionId: any) {
    return this.dataService.getData('/api/ServiceChangeRequest/GetServiceChangeRequestByConnectionId/?connectionId=' + connectionId, true);
  }

  getThreeMonthTerminationFee(data: any) {
    return this.dataService.post('/api/ServiceChangeRequest/getThreeMonthTerminationFee', data);
  }
 

  getTransferAccountApplicationsSearch(searchQuery: string) {
    return this.dataService.getRecordWithParams('/api/Application/getTransferAccountApplicationsSearch/', searchQuery);
  }

  getTransferAccountSearchWithStatusType(searchItem: any) {
    return this.dataService.getRecord('/api/Application/getTransferAccountSearchWithStatusType/' + searchItem);
  }

  getApplicationsAndRequest(searchQuery: string) {
    return this.dataService.getRecordWithParams('/api/Application/getApplicationsBySearchQuery', searchQuery);
  }

  getLandingApplicationsAndRequest(searchQuery: string) {
    return this.dataService.getRecordWithParams('/api/Application/getLandingApplicationsBySearchQuery', searchQuery);
  }

  getLandingApplicationsAndRequestCount(searchQuery: string) {
    return this.dataService.getRecord('/api/Application/getLandingApplicationsCount');
  }

  getUserApplicationsAndRequest(searchQuery: any) {

    return this.dataService.getRecordWithParams('/api/Application/getUserApplicationsBySearchQuery', searchQuery);
  }

  getNumberOfApplicationAndRequest(searchQuery: any) {
    return this.dataService.getRecordWithParams('/api/Application/getNumberOfApplicationAndRequest', searchQuery);
  }

  getApplicationsSearch(searchQuery: string) {
    return this.dataService.getRecordWithParams('/api/Application/getApplicationSearch/', searchQuery);
  }

  getManageFibreApplicationsSearch(searchQuery: string, refresh: boolean) {
    return this.dataService.getDataWithParams('/api/Application/getApplicationSearch/', searchQuery, refresh);
  }

  getCancellationApplicationsSearch(searchQuery: string) {
    return this.dataService.getRecordWithParams('/api/Application/getCancellationApplicationSearch/', searchQuery);
  }
  
  UploadLegalCollectionData(data){
    return this.dataService.post('/api/Application/UploadLegalCollectionData',data);
  }

  UploadRevokeLegalCollectionData(data){
    return this.dataService.post('/api/Application/BulkRevertLegalCollection',data);
  }

  getLegalCollections(searchQuery: string) {
    return this.dataService.getRecordWithParams('/api/Application/getLegalCollections/', searchQuery);
  }



  getSearchWithStatusType(searchItem: any) {
    return this.dataService.getRecord('/api/Application/getSearchWithStatusType/' + searchItem);
  }



  getRainSearchWithStatusType(searchItem: any) {
    return this.dataService.getRecord('/api/Application/getRainSearchWithStatusType/' + searchItem);
  }

  getRequestedSearch(searchQuery: any) {
    return this.dataService.getRecordWithParams('/api/Application/getRequestedSearch/', searchQuery);
  }

  getUserNamesByUserid(userid: number) {

    return this.dataService.getRecord('/api/Connection/GetUserNamesByUserId/?UserId=' + userid);
  }

  getAddressChangeApplicationByUserid(userid: number) {

    return this.dataService.getRecord('/api/Connection/GetAddressChangeApplicationByUserid/?UserId=' + userid);
  }

  getCompletedApplicationByUserid(userid: number) {

    return this.dataService.getRecord('/api/Connection/GetCompletedApplicationByUserid/?UserId=' + userid);
  }

  deleteApplication(deleteApplication: any) {

    return this.dataService.post('/api/Application/DeleteApplication', deleteApplication);
  }
  cancelledReason(applicationid: number, reason: string)  {

    return this.dataService.getRecord('/api/Application/cancelledReason/?applicationId=' + applicationid + '&reason=' + reason);
  }
  updateWayBillNo(post: any) {

    return this.dataService.post('/api/Application/updateWayBillNo', post);
  }
  cancelledReasonForVumatelAPI(applicationid: number, reason: string) {

    return this.dataService.getRecord('/api/Application/cancelledReasonForVumatelAPI/?applicationId=' + applicationid + '&reason=' + reason);
  }
  vumatelpendingapplications(vumatelorderid: number) {

    return this.dataService.getRecord('/api/VumatelOrderDetail/getApplicationsByVumatelId/vumatelorderId=' + vumatelorderid);
  }

  getIsCoustomerHaveRainApplication() {
    return this.dataService.getRecord('/api/Application/getIsCoustomerHaveRainApplication');
  }

  getSalesUserCountPerDay(searchQuery: string) {
    return this.dataService.getRecordWithParams('/api/Application/getSalesUserCountPerDay', searchQuery);
  }

  getSalesUserCountPerMonth(searchQuery: string) {
    return this.dataService.getRecordWithParams('/api/Application/getSalesUserCountPerMonth', searchQuery);
  }

  getSalesUserCountAllUserPerDay(searchQuery: string) {
    return this.dataService.getRecordWithParams('/api/Application/getSalesUserCountAllUserPerDay', searchQuery);
  }

  getSalesUserCountAllUserPerMonth(searchQuery: string) {
    return this.dataService.getRecordWithParams('/api/Application/getSalesUserCountAllUserPerMonth', searchQuery);
  }

  getServiceProviderCountAllUserPerMonth(searchQuery: string) {
    return this.dataService.post('/api/Application/getServiceProviderCountAllUserPerMonth', searchQuery);
  }

  getSalesUserCountHCPerMonth(searchQuery: string) {
    return this.dataService.getRecordWithParams('/api/Application/getSalesUserCountHCPerMonth', searchQuery);
  }

  getSalesUserCountHCPerYear(searchQuery: string) {
    return this.dataService.getRecordWithParams('/api/Application/getSalesUserCountHCPerYear', searchQuery);
  }

  getDeletedCountPerSalesUser() {
    return this.dataService.getRecord('/api/Application/getDeletedCountPerSalesUser');
  }

  getDashboardCardDetails(searchQuery: string) {
    return this.dataService.getRecordWithParams('/api/Application/GetDashboardCardDetails', searchQuery);
  }

  getDashboardConnectionDetails(searchQuery: string) {
    return this.dataService.getRecordWithParams('/api/Application/GetDashboardActualConnectionDetails', searchQuery);
  }

  getUpdatedApplicationCount(isLte:boolean,month=null,year=null) {
    return this.dataService.getRecord('/api/Application/GetUpdatedApplicationCount?isLte=' + isLte+'&Month='+month+'&Year='+year);
  }


  getPaymentProcess(searchQuery: string) {
    return this.dataService.post('/api/payment/creditCardCheckOut', searchQuery);
  }

  getPaymentProcessStatus(searchQuery: string) {
    return this.dataService.post('/api/payment/getCreditCardPayment', searchQuery);
  }

  getAllCreditCardPayment() {
    return this.dataService.getRecord('/api/payment/getAllCreditCardPayment');
  }

  getVumatelIgniteUser() {
    return this.dataService.getRecord('/api/Application/getVumatelIgniteUser');
  }

  getCreditCardPortingDetails(searchQuery: string) {
    return this.dataService.post('/api/OrderDetail/getCreditCardPortingDetails', searchQuery);
  }

  getCustomerIsReceiveOwnershipResubmitted() {
    return this.dataService.getRecord('/api/Application/getCustomerIsReceiveOwnershipResubmitted');
  }

  getOwnershipResubmittedOnceOffId() {
    return this.dataService.getRecord('/api/Application/getOwnershipResubmittedOnceOffId');
  }

  getWANDowngradeCost(applicationId: string) {

    return this.dataService.getRecord('/api/Application/getWANDowngradeCost/' + applicationId);
  }

  getTariffDetailsByAppId(applicationId: string) {

    return this.dataService.getRecord('/api/Application/getTariffDetailsByAppId/' + applicationId);
  }

  getServiceProviderCountPerSelectedMonth(searchQuery: string) {
    return this.dataService.getRecordWithParams('/api/Application/getServiceProviderCountPerSelectedMonth', searchQuery);
  }

  getSelectedServiceProviderCountPerSelectedMonth(searchQuery: string) {
    return this.dataService.getRecordWithParams('/api/Application/getSelectedServiceProviderCountPerSelectedMonth', searchQuery);
  }

  getApprovedServiceProviderCountPerSelectedMonth(searchQuery: string) {
    return this.dataService.getRecordWithParams('/api/Application/getApprovedServiceProviderCountPerSelectedMonth', searchQuery);
  }

  getServiceProviderCountPerSelected3Month(searchQuery: string) {
    return this.dataService.getRecordWithParams('/api/Application/getServiceProviderCountPerSelected3Month', searchQuery);
  }

  getUserSPConnectionCount() {
    return this.dataService.getRecord('/api/Application/getUserSPConnectionCount');
  }

  getFrogFootLinkApplicationList() {
    return this.dataService.getRecord('/api/Application/getFrogFootLinkApplicationList');
  }

  getSubCategoryIdByProductId(productId: number) {

    return this.dataService.getRecord('/api/Application/getSubCategoryIdByProductId/' + productId);
  }

  getIsVumatelAPIUser() {
    return this.dataService.getRecord('/api/User/getIsVumatelAPIUser');
  }

  getServiceProviderLeadUser() {
    return this.dataService.getRecord('/api/User/getServiceProviderLeadUser');
  }

  getIsAEXAPIUser() {
    return this.dataService.getRecord('/api/User/getIsAEXAPIUser');
  }

  getIsFibreCompareAPIUser() {
    return this.dataService.getRecord('/api/User/getIsFibreCompareAPIUser');
  }

  getPreferedType() {
    return this.dataService.getRecord('/api/user/getPreferedType');
  }

  getDeactivatedApplicationsSearch(searchQuery: string, refresh: boolean) {
    return this.dataService.getDataWithParams('/api/Application/getDeactivateApplicationSearch/', searchQuery, refresh);
  }

  getOctotelFrogfootOwnrouterApplication(searchQuery: string, refresh: boolean) {
    return this.dataService.getDataWithParams('/api/Application/getOctotelFrogfootOwnrouterApplication/', searchQuery, refresh);
  }
  getProductsByConnectionId(connectionId:number) {
    return this.dataService.getData('/api/product/getProductsByConnectionId/' + connectionId, false);
  }

  getApplicationsForPaymentArranges(search: string) {
    return this.dataService.getRecord('/api/Application/getApplicationsForPaymentArranges/' + search);
  }

  getApplicationsForrevokePaymentArranges(search: string) {
    return this.dataService.getRecord('/api/Application/getApplicationsForRevertPaymentArranges/' + search);
  }

  submitPaymentArrangement(payload: string) {
    return this.dataService.post('/api/Application/submitPaymentArrangement', payload);
  }
  revokePaymentArrangement(payload: string) {
    return this.dataService.post('/api/Application/RevokePaymentArrangement', payload);
  }

   getserviceProviderDashboard(date,month,year) {
    return this.dataService.getRecord('/api/coverage/getserviceProviderDashboard/'+date+'/'+month+'/'+ year);
  }
}
